import { baseUrl } from '../http'
import axios from 'axios'

export const documentsApi = {

  update (payload) {
    const { docId, companyId } = payload

    return axios.put(`${baseUrl}/company/${companyId}/document/${docId}`, payload)
  }
}
